const APP_NAME = 'LawLytics AI';
const RAW_INERTIA_TITLE_PREFIX = '__raw_inertia_title__:';

export function formatInertiaTitle(title?: string | null): string {
  if (!title) return APP_NAME;
  if (title.startsWith(RAW_INERTIA_TITLE_PREFIX)) {
    return title.slice(RAW_INERTIA_TITLE_PREFIX.length);
  }

  return `${title} | ${APP_NAME}`;
}

export function rawInertiaTitle(title: string): string {
  return `${RAW_INERTIA_TITLE_PREFIX}${title}`;
}
